<script>
  // Thin wrapper around vanilla moveable. Moveable options (target,
  // draggable, resizable, …) pass straight through and stay in sync; an
  // on<Event> prop (onDrag, onResizeEnd, …) receives the matching moveable
  // event.
  import VanillaMoveable, { EVENTS, PROPERTIES } from "moveable"
  import { onMount } from "svelte"

  let props = $props()

  let element
  let moveable = null

  const options = $derived(
    Object.fromEntries(
      PROPERTIES.filter((name) => name in props).map((name) => [name, props[name]])
    )
  )

  onMount(() => {
    moveable = new VanillaMoveable(element, { ...options, warpSelf: true })
    for (const name of EVENTS) {
      const handler = `on${name[0].toUpperCase()}${name.slice(1)}`
      moveable.on(name, (event) => props[handler]?.(event))
    }
    return () => moveable.destroy()
  })

  $effect(() => {
    moveable?.setState(options)
  })

  export function updateRect() {
    moveable?.updateRect()
  }
</script>

<div bind:this={element}></div>
